import { HSE_TERMS, type HseTermKey } from '../constants/hseTerms';
import type { HseWeeklyDraft, HseWeeklyReport } from '../types/hse-weekly-report.type';

export function emptyDraft(): HseWeeklyDraft {
  return Object.fromEntries(
    HSE_TERMS.map((term) => [term.key, { notes: '', weeklyCount: '0' }]),
  ) as HseWeeklyDraft;
}

export function draftFromReport(report: HseWeeklyReport): HseWeeklyDraft {
  const draft = emptyDraft();
  for (const row of report.rows) {
    if (row.term_key in draft) {
      draft[row.term_key as HseTermKey] = {
        notes: row.notes ?? row.executive_summary ?? '',
        weeklyCount: String(row.weekly_count ?? 0),
      };
    }
  }
  return draft;
}
